import React from "react";
import PropTypes from "prop-types";
import Link from "gatsby-link";
import { Emojione } from "react-emoji-render";

const SelectLanguage = props => {
  const link = props.langs.map(lang => {
    if (!lang.selected) {
      return (
        <Link
          to={`/${lang.langKey}/`}
          key={lang.langKey}
          style={{
            padding: "0 20px",
            border: "0",
            color: "White",
            textAlign: "center",
            textDecoration: "none",
            display: "inline-block",
            lineHeight: "26px"
          }}
        >
          <li
            selected={lang.selected}
            style={{
              listStyleType: "none",
              padding: 0,
              margin: 0,
              display: "inline-block"
            }}
          >
            <p style={{ fontSize: "12px", display: "inline" }}>
              {lang.langKey === "es" ? "Cambiar " : "Change "}
            </p>
            {lang.langKey === "es" ? (
              <Emojione svg text="🇪🇸" />
            ) : (
              <Emojione svg text="🇺🇸" />
            )}
          </li>
        </Link>
      );
    }
  });

  return (
    <section
      style={{
        fontFamily: "Raleway, Helvetica, sans-serif",
        display: "inline-block"
      }}
    >
      <ul
        style={{
          padding: 0,
          listStyleType: "none",
          height: "26px",
          width: "100%",
          display: "block",
          alignContent: "space-between",
          margin: "5px 0"
        }}
      >
        {link}
      </ul>
    </section>
  );
};

SelectLanguage.propTypes = {
  langs: PropTypes.array
};

export default SelectLanguage;



// WEBPACK FOOTER //
// ./src/components/SelectLanguage.js